import { apiUrl } from './apiBase';

const TOKEN_KEY = 'auth_token';

export function setAuthToken(token: string): void {
  localStorage.setItem(TOKEN_KEY, token);
}

export function getAuthToken(): string | null {
  return localStorage.getItem(TOKEN_KEY);
}

export function clearAuthToken(): void {
  localStorage.removeItem(TOKEN_KEY);
}

// The API authenticates by bearer token, not by cookie. OVH's reverse proxy strips
// the standard Authorization header on the public domain, so the token also rides
// under X-Auth-Token — the backend accepts either.
export async function authFetch(path: string, init: RequestInit = {}): Promise<Response> {
  const token = getAuthToken();
  const headers: Record<string, string> = { ...(init.headers as Record<string, string>) };

  if (token) {
    headers.Authorization = `Bearer ${token}`;
    headers['X-Auth-Token'] = token;
  }

  return fetch(apiUrl(path), { ...init, headers });
}
